
export const ecommerceStats: EcommerceStat[] = [
  { id: "orders", label: "Total Orders", value: "1,284", change: "+12.5%", bg: "bg-primary-soft", color: "text-primary" },
  { id: "revenue", label: "Revenue", value: "$48,290", change: "+8.2%", bg: "bg-yellow-soft", color: "text-yellow" },
  { id: "customers", label: "Customers", value: "3,842", change: "+15.3%", bg: "bg-teal-soft", color: "text-teal" },
  { id: "returns", label: "Returns", value: "2.4%", change: "-0.8%", bg: "bg-pink-soft", color: "text-pink" },
];

export const revenueData: RevenuePoint[] = [
  { month: "Jan", revenue: 3200, orders: 120 },
  { month: "Feb", revenue: 4100, orders: 145 },
  { month: "Mar", revenue: 3800, orders: 132 },
  { month: "Apr", revenue: 5200, orders: 178 },
  { month: "May", revenue: 4800, orders: 165 },
  { month: "Jun", revenue: 6100, orders: 210 },
  { month: "Jul", revenue: 5800, orders: 195 },
];

export const topProducts: Product[] = [
  { id: "1", name: "Wireless Headphones", sales: 342, revenue: "$12,390", trend: "+18%" },
  { id: "2", name: "Smart Watch Pro", sales: 289, revenue: "$9,840", trend: "+12%" },
  { id: "3", name: "Laptop Stand", sales: 256, revenue: "$5,120", trend: "+8%" },
  { id: "4", name: "USB-C Hub", sales: 198, revenue: "$3,960", trend: "+5%" },
  { id: "5", name: "Mechanical Keyboard", sales: 167, revenue: "$8,350", trend: "+22%" },
];

export const recentOrders: Order[] = [
  { id: "#ORD-7821", customer: "Alice Martin", product: "Wireless Headphones", amount: "$129.00", status: "completed" },
  { id: "#ORD-7820", customer: "Bob Dupont", product: "Smart Watch Pro", amount: "$299.00", status: "shipped" },
  { id: "#ORD-7819", customer: "Claire Bernard", product: "Laptop Stand", amount: "$49.00", status: "pending" },
  { id: "#ORD-7818", customer: "David Leroy", product: "USB-C Hub", amount: "$39.00", status: "completed" },
];

export const categorySales: CategorySale[] = [
  { name: "Electronics", value: 42, color: "#4680ff" },
  { name: "Accessories", value: 28, color: "#13c2c2" },
  { name: "Clothing", value: 18, color: "#ffb800" },
  { name: "Other", value: 12, color: "#ff5a87" },
];
